module.exports = __webpack_public_path__ + "static/AboutUs-VikrantGuptaProfilePic-1253e5de60e6ef7657714cac1eab6df5.jpg";